import { getTabId } from "src/utils/utils";

export default function createActionEnhancerMiddleware () {
  return ({ getState }) => next => action => {
    const state = getState();
    const tabId= getTabId();

    action.currentClientId = state.authentication.getIn(['tabs', tabId, 'clientId']);
    if (!action.currentClientId) {
      const activeTab = localStorage.getItem('activeTab');
      if (activeTab ) {
        action.currentClientId = localStorage.getItem(activeTab);
      } else {
        action.currentClientId = state.authentication.getIn(['tabs'])?.first().clientId || null;
      }
    }


    return next(action);
  };
}
